import { z } from 'zod'
import {
	LINK_KINDS,
	LINK_VIEWS
} from '@/routes/(private)/(shell)/-lib/link-views'

/**
 * URL-owned filters for `/admin/links` — every one `GET /links/organization`
 * offers, and nothing else: there is no organization field here for the
 * reason `AdminLinksFilters` states.
 *
 * `view` is the state filter, opening on `live` like "my active links" does
 * (OPSSTD-8807): the page is titled «Link attivi», and an administrator
 * deciding what to shut off has nothing to do with a link already revoked or
 * expired.
 */
export const adminLinksSearchSchema = z.object({
	creatorId: z.string().optional(),
	kind: z.enum(LINK_KINDS).default('all'),
	view: z.enum(LINK_VIEWS).default('live'),
	expiresWithinDays: z.coerce.number().int().positive().optional(),
	hasPassword: z.enum(['true', 'false']).optional()
})
